const actions = {
  SET_REFETCH_BOOKINGS: 'bookingsSlice/SET_REFETCH_BOOKINGS',
};
const initialState = {
  refetchBookings: true,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_REFETCH_BOOKINGS: {
      const newState = { ...state, ...action.payload };
      return newState;
    }
    default:
      return state;
  }
}

export const selectRefetchBookings = state => state.bookingsSlice.refetchBookings
